module.exports = __webpack_public_path__ + "static/media/NoCodeFound.21802357.svg";